import { jsx, css } from '@emotion/react';
import _ from 'lodash';

import Section from './oc-section';
import { connectLocation } from '../../location/LocationConnectors';
import Icon from '../oc-icon';
import Link from '../oc-link';
import MediaObject from '../oc-media-object';
import RichText from '../oc-rich-text';

const styles = css`
  .products {
    display: flex;
    flex-dirextion: row;
    flex-wrap: wrap;
    width: 80%;
    margin: 0 10%;

    .product {
      width: 50%;
      margin-bottom: 5px;

      a {
        text-decoration: none;

        &:hover {
          color: #d40f7d;
          text-decoration: none;

          .media-body h6 {
            color: #d40f7d;
          }
        }
      }
    }

    .oc-media-object {
      img {
        width: 75px;
        height: 75px;
      }
      a {
        max-width: 90%;
      }
      img + .media-body {
        padding: 0 15px;
      }
    }

    @media (max-width: 1199px) {
      .product {
        width: 100%;
      }
    }

    @media (max-width: 767px) {
      margin: 0 0;
      width: 100%;

      .oc-media-object > div {
        padding-right: 15px;
      }
    }
  }
`;

const RelatedProducts = connectLocation(({ t, locale, products, heading, anchor, className, productCategory }) => (
  <Section anchor={anchor} className="oc-related-products" css={styles} className={className}>
    <h2>
      <RichText content={heading} />
    </h2>
    <div className="products">
      {products.map(({ slug, name, description, images = {} }) => {
        const { product_thumb = {} } = images;

        return (
          <div className="product" key={slug}>
            <Link
              href={`/${locale.code.toLowerCase()}/${productCategory}/product${
                productCategory === 'insulation' ? 's' : ''
              }/${slug}`}
              data-track="learn-more"
              data-track-destination={name}
            >
              <MediaObject img={product_thumb.url} alt={name}>
                <h6>
                  <RichText content={name} />
                </h6>
              </MediaObject>
            </Link>
          </div>
        );
      })}
    </div>
  </Section>
));

RelatedProducts.WrappedComponent.displayName = 'RelatedProducts';

export default RelatedProducts;
